// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const ArrowUp = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='3px'
    >
      <polygon
        xmlns='http://www.w3.org/2000/svg'
        points='1.5 34.8 23.8 12.5 46.2 34.8 45.5 35.5 23.8 13.9 2.2 35.5 1.5 34.8'
      />
    </svg>
  );
};
